import React from 'react'
import PropTypes from 'prop-types'
import SpinnerInput from '@/modules/react/inputs/spinner_input/react_spinner_input'
import { letterHeaderConstants } from 'base/util/constants'

const { DEFAULT_FONT_SIZE } = letterHeaderConstants

const FontSizeInput = (props) => {
  const { canvas, visible, value, onChange } = props
  const activeClass = !visible ? '' : 'u_hidden'

  const changeFontSize = (value) => {
    if (!canvas) return

    let parsedValue = parseInt(value)
    const textElement = canvas.getActiveObject()
    if (!parsedValue || !textElement) {
      return
    }

    if (parsedValue === 0) {
      parsedValue = DEFAULT_FONT_SIZE
    } else if (parsedValue > 100 || parsedValue < 10) {
      return
    }

    textElement.set({ lockScalingX: false, lockScalingY: false })
    textElement.set('fontSize', parsedValue)

    canvas.renderAll()
    textElement.set({ lockScalingX: true, lockScalingY: true })
    onChange && onChange({ selectedFontSize: parsedValue })
  }

  return (
    <div className={`letterHeaderTools_fontSize ${activeClass}`}>
      <SpinnerInput
        label='Größe'
        symbol='px'
        precision={0}
        min={10}
        max={100}
        leftLabel={true}
        hasBorder={true}
        selectOnFocus={true}
        value={value}
        onChange={changeFontSize} />
    </div>
  )
}

FontSizeInput.propTypes = {
  canvas: PropTypes.object,
  visible: PropTypes.bool,
  value: PropTypes.number,
  onChange: PropTypes.func,
}

export default FontSizeInput
